import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Query from '@/components/Query';
import CertInfo from '@/components/CertInfo';
import CardLookUp from '@/components/CardLookUp';
import Login from '@/components/Login';
import Dashboard from '@/components/Dashboard';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/query',
        name: 'Query',
        component: Query,
    },
    {
      path: '/',
      name: 'Query',
      component: Query,
    },
    {
      path: '/certinfo',
      name: 'CertInfo',
      component: CertInfo,
    },
    {
        path: '/cardlookup/:serial',
        name: 'CardLookUp',
        component: CardLookUp,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requireAuth: true,  // 判断是否需要登录
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js